export const startsWith = (event: string, prefixes: string[]) =>
  prefixes.some((prefix) => event.startsWith(prefix));
export const endsWith = (event: string, prefixes: string[]) =>
  prefixes.some((prefix) => event.endsWith(prefix));

export function mapObject<T, R>(
  obj: Record<string, T> | undefined | null,
  mapper: (v: T, key: string) => R,
) {
  if (!obj) return {};
  return Object.keys(obj).reduce<Record<string, R>>(
    (acc, key) => ({
      ...acc,
      [key]: mapper(obj[key], key),
    }),
    {},
  );
}

// This function is a duplicate of consumer-v2
// packages/consumer-v2/src/actions/end-action.ts
export const addHttps = (url: string) => {
  const pattern = /^(https?|ftp):\/\//;

  if (!pattern.test(url)) {
    return `https://${url}`;
  }
  return url;
};
